import { TProps as TLayoutProps } from './dropzone/components/Layout/types/TProps';

export const FileUploadLayout = ({ input, dropzoneProps, files, extra: { maxFiles } }: TLayoutProps) => {
  return (
    <div>
      <div {...dropzoneProps}>{files.length < maxFiles && input}</div>
    </div>
  );
};
